// extracted by mini-css-extract-plugin
export default {"logo":"styles_logo__XzzR6","logo_highlight":"styles_logo_highlight__6-2rQ","sm":"styles_sm__OxLtH","md":"styles_md__JIYPa","xl":"styles_xl__BjLYc"};